<template>
<div>
    <div class="absolute bottom-10 right-[50%] translate-x-1/2 flex flex-row space-x-2 " style="bottom: 10px">
        <a @click="swicthLanguage('it')">
        <country-flag country='it'/>
        </a>
        <a @click="swicthLanguage('en')">
        <country-flag country='gb'/>
        </a>
        <a @click="swicthLanguage('es')">
        <country-flag country='es'/>
        </a>
    </div>
</div>
</template>

<script>
export default {
    name: "SwitchLanguages",
    data() {
        return {
        };
    },
    methods: {
        swicthLanguage(lang) {
            this.setLang(lang);
            this.$i18n.locale = lang;
        }
    },
}
</script>

<style lang="scss" scope>
/*  */
</style>